import { z } from "zod";
import { AVAILABILITY_REPLY_STATUSES } from "../types/match-availability.js";

// Parent/player reply for a player on a fixture. team is resolved server-side
// from the seeded availability row, so the caller only supplies player + status.
export const respondAvailabilitySchema = z.object({
  player_id: z.string().min(1, "Player is required"),
  status: z.enum(AVAILABILITY_REPLY_STATUSES),
  note: z.string().trim().max(280, "Note must be 280 characters or fewer").optional(),
});

export type RespondAvailabilityInput = z.infer<typeof respondAvailabilitySchema>;
